import "babel-polyfill";

// SCSS entry file
import "../_scss/main.scss";

// Root component
import "./components/root";
// import './cookie-script-localstorage';

// Load all image files from a directory
//require.context( '../_img/', true, /.*/ );
import "off-canvas";



// WEBPACK FOOTER //
// ./assets/_js/main.js